import { render, staticRenderFns } from "./NewDirectReInsurance.vue?vue&type=template&id=e9577f18&scoped=true&"
import script from "./NewDirectReInsurance.vue?vue&type=script&lang=js&"
export * from "./NewDirectReInsurance.vue?vue&type=script&lang=js&"
import style0 from "./NewDirectReInsurance.vue?vue&type=style&index=0&id=e9577f18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9577f18",
  null
  
)

export default component.exports